export const GettingStartedData = [
  {
    imageName: 'static/img/cml/getting_started_one.png',
  },
  {
    imageName: 'static/img/cml/getting_started_two.png',
  },
  {
    imageName: 'static/img/cml/getting_started_three.png',
  },
];

export const GettingStartedMobileData = [
  {
    imageName: 'static/img/cml/getting_started_mobile_one.png',
  },
  {
    imageName: 'static/img/cml/getting_started_mobile_two.png',
  },
  {
    imageName: 'static/img/cml/getting_started_mobile_three.png',
  },
];
